function onEntry(entry) {
  entry.forEach((change) => {
    if(change.isIntersecting) {
		change.target.classList.add('isonscreen');
    } else {
		change.target.classList.remove('isonscreen');
	}
  });
}

let options = {
  threshold: [0.1]
};

let observer = new IntersectionObserver(onEntry, options);

let elements = document.querySelectorAll('.onscreen');

for (let elm of elements) {
  observer.observe(elm);
}

document.addEventListener('DOMContentLoaded', function () {
    const players = document.querySelectorAll('.js-plyr');

    players.forEach((el) => {
      new Plyr(el, {
        controls: [
          'play-large',
          'play',
          'progress',
          // 'current-time',
          'mute',
          // 'volume',
          'fullscreen'
        ]
      });
    });
  });

document.addEventListener('shopify:section:load', function () {
  const players = document.querySelectorAll('.js-plyr');

  players.forEach((el) => {
    if (!el.dataset.plyrInitialized) {
      new Plyr(el);
      el.dataset.plyrInitialized = "true";
    }
  });
});